<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1 v-if="isNew">{{ $t('add_product.new_product') }}</h1>
      <h1 v-else>{{ $t('add_product.edit_product') }}</h1>
    </div>
    <div class="details-component__content content">
      <form class="form">
        <fieldset class="form__fieldset">
          <div class="form__field" :class="{'form__field_error' : errors.has('email')}" >
            <label for="email" class="form__label">{{ $t('common.email') }}</label>
            <input type="text" class="form__input" name="permit_count" id="permit_count" value=""
             v-model="form.email" v-validate data-vv-rules="required|email"
              data-vv-as="$t('add_account.email')" data-vv-delay="1000"
            :placeholder="$t('common.email')" />
          </div>

          <div class="form__field" :class="{'form__field_error' : errors.has('name')}">
            <label for="name" class="form__label">{{ $t('common.name') }}</label>

            <input type="text" class="form__input" name="name" id="name" value=""
              v-model="form.name"
              v-validate
              data-vv-rules="required|min:3|max:255"
              data-vv-as="name"
              data-vv-delay="1000"
              :placeholder="$t('common.name')"
             />
            <tooltip v-show="errors.has('name')" class="form__validation">{{ $t('errors.product_field_required') }}</tooltip>
          </div>
          
        </fieldset>
        <div class="form__buttons buttonset">
          <router-link v-if="isNew" :to="{ name: 'accounts' }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <router-link v-else :to="{ name: 'account', params: { id: $route.params.id }}" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <button type="submit" class="buttonset__button btn btn--main" v-on:click.prevent.stop="onSubmit()">
          {{ $t('common.save') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>
</template>
<script>
  import { mapGetters } from 'vuex';
  import * as mTypes from 'store/mutation-types';
  import Tooltip from 'common/Tooltip';

  export default {
    data() {
      return {
        form: {},
      };
    },
    computed: {
      isNew() {
        return !this.$route.params.id;
      },
      ...mapGetters({
        account: 'accounts/account/account',
        user: 'user/user/user',
        accountError: 'accounts/account/error',
      }),
    },
    mounted() {
      this.fetchAccount();
    },
    components: {
      Tooltip,
    },
    methods: {
      fetchAccount() {
        this.$store.dispatch('accounts/account/fetch', { id: this.$route.params.id }).then(() => {
          this.form = this.account;
        });
      },
      onSubmit() {
        this.$validator.validateAll()
          .then((success) => {
            if (success) {
              if (this.$route.params.id) {
                this.form.id = this.$route.params.id;
              }
              this.$store.dispatch('accounts/account/save', this.form).then(() => {
                if (!this.accountError) {
                  this.form = {};
                  this.$store.commit(`accounts/accounts/${mTypes.EDIT_DATA}`, this.account);
                  this.$router.push({ name: 'account', params: { id: this.account.id } });
                }
              });
            }
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/accounts/AddAccountView.vue